import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter, usePathname } from '@/lib/router';
import { Navigation } from '@pcmp/react-coworker-components';
import { ROUTES } from '@/lib/constants';
import { useActiveLocationPermissions } from '@/redux/features/shopping-bag/hooks';
import { useSession } from '@/redux/features/session/hooks';

const { BottomNavItem, BottomNavigation } = Navigation;

const NavBar = () => {
  // Hooks
  const { t } = useTranslation();
  const router = useRouter();
  const route = usePathname();
  // Data
  const session = useSession();
  const userRoles = useActiveLocationPermissions();
  // Event handlers
  const navigateTo = useCallback(
    (path: string) => () => router.push(path),
    [router]
  );

  return (
    <div className="w-full fixed bottom-0 left-0 md:hidden z-[150]">
      <BottomNavigation>
        {ROUTES.map(({ path, translationKey, icon, isVisible, isActive }) => {
          if (
            !isVisible({
              isAdmin: userRoles.isAdmin,
              isInvitation: !!session.invitationToken,
              isPlatformOwner: userRoles.isSuperAdmin,
            })
          )
            return null;

          return (
            <BottomNavItem
              key={path}
              text={t(translationKey)}
              icon={icon}
              onClick={navigateTo(path)}
              active={isActive(route || '')}
            />
          );
        })}
      </BottomNavigation>
    </div>
  );
};
export default NavBar;
